import { LightstepDeploymentEnvironment } from '@domgen/dgx-fe-lightstep';

export const DEFAULT_ENVIRONMENT = {
  requestSource: 'DandGUK',
  requestAction: 'PR',
  channelCode: 'DGX',
  countryCode: 'GB',
  gaClientName: 'DG PR',
  lightstep: {
    collectorUrl: 'https://ingest.lightstep.com/traces/otlp/v0.9',
    debug: false,
    deploymentEnvironment: LightstepDeploymentEnvironment.Development,
    serviceName: 'dg-product-replacement',
    serviceVersion: '1.0.0',
    traceHeaderWhitelist: [],
  },
  buildFeatures: {},
};
